var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93042 8.54329C1.4188 8.54381 0.928368 8.74733 0.566602 9.10908C0.20487 9.47081 0.00147812 9.96128 0.000943405 10.4729V11.7829C-0.0153747 12.3048 0.180573 12.8111 0.54401 13.186C0.907447 13.5609 1.4073 13.7725 1.92948 13.7725C2.45166 13.7725 2.95152 13.5609 3.31495 13.186C3.67839 12.8111 3.87433 12.3048 3.85802 11.7829V10.4729C3.85763 9.96155 3.65437 9.47135 3.29303 9.10975C2.9317 8.74802 2.44174 8.54436 1.93042 8.54332V8.54329Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3988 4.71042C6.88718 4.71094 6.39675 4.91446 6.03499 5.27621C5.67325 5.63794 5.46973 6.12841 5.46933 6.64003V11.7903C5.45301 12.3122 5.64896 12.8185 6.01239 13.1934C6.37583 13.5683 6.87569 13.7799 7.39787 13.7799C7.92005 13.7799 8.4199 13.5683 8.78334 13.1934C9.14677 12.8185 9.34271 12.3122 9.3264 11.7903V6.64003C9.32588 6.12868 9.12275 5.63848 8.76142 5.27688C8.40008 4.91515 7.90999 4.71145 7.3988 4.71042Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 0C12.3562 0.000913789 11.8666 0.204304 11.5052 0.565659C11.1439 0.92689 10.9405 1.41669 10.9395 1.92764V11.7904C10.9232 12.3123 11.1192 12.8186 11.4826 13.1935C11.846 13.5684 12.3459 13.78 12.8681 13.78C13.3903 13.78 13.8901 13.5684 14.2536 13.1935C14.617 12.8186 14.8129 12.3123 14.7966 11.7904V1.92764C14.7957 1.41629 14.5921 0.926355 14.2303 0.565023C13.8686 0.203692 13.3784 0.000367614 12.8672 0Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.329f5d3e4a22ab241e9ff5a2b1b83a7c.svg";
export { ForwardRef as ReactComponent };